import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    approvalrules: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_APPROVALRULE_SELECT_IDS (store, ids) {
      store.approvalrules.selectIds = ids
    },
    REMOVE_APPROVALRULE_SELECT_IDS (store, ids) {
      store.approvalrules.selectIds = store.approvalrules.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_APPROVALRULE_SELECT_ID (store, id) {
      store.approvalrules.selectId = id
    },
    SET_APPROVALRULE_FILTERS (store, filters) {
      store.approvalrules.filters = filters
    },
    SET_APPROVALRULE_PAGINATE (store, val) {
      store.approvalrules.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getApprovalrules: (store, getters) => {
      return store.approvalrules.selectIds.map((id) => {
        return getters['entities/approvalrules/find'](id)
      })
    },
    getApprovalrulesFilters: (store, getters) => {
      return store.approvalrules.filters
    },
    getApprovalrulesPaginate: (store, getters) => {
      return store.approvalrules.paginate
    },
    getApprovalrule: (store, getters) => {
      return getters['entities/approvalrules/find'](store.approvalrules.selectId) || {}
    }
  },
  actions: {
    /*
    selectApprovalrules
    */
    selectApprovalrules ({commit, dispatch, getters, state}, filters) {
      return dispatch('getApprovalrules', filters)
      .then((response) => {
        commit('SET_APPROVALRULE_FILTERS', filters)
        commit('SET_APPROVALRULE_PAGINATE', response)
        commit('SET_APPROVALRULE_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectApprovalrules
    */
    refreshSelectApprovalrules ({commit, dispatch, getters, state}) {
      return dispatch('selectApprovalrules', getters.getApprovalrulesFilters)
    },
    /*
    selectApprovalrule
    */
    selectApprovalrule ({commit, dispatch, getters, state}, id) {
      return dispatch('getApprovalruleById', id)
      .then((response) => {
        commit('SET_APPROVALRULE_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getApprovalrules
    */
    getApprovalrules ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/approvalrules`, {params: filters})
      .then((response) => {
        return dispatch('entities/approvalrules/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.approvalrules || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getApprovalruleById
    */
    getApprovalruleById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/approvalrules/${id}`)
      .then((response) => {
        return dispatch('entities/approvalrules/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.approvalrules[0]
      })
    },
    /*
    createApprovalrule
    */
    createApprovalrule ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/approvalrules`, data)
      .then((response) => {
        return dispatch('entities/approvalrules/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.approvalrules[0]
      })
    },
    /*
    updateApprovalrule
    */
    updateApprovalrule ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/approvalrules/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/approvalrules/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.approvalrules[0]
      })
    },
    /*
    deleteApprovalrule
    */
    deleteApprovalrule ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/approvalrules/${id}`)
      .then((response) => {
        commit('REMOVE_APPROVALRULE_SELECT_IDS', [id])
        dispatch('entities/approvalrules/delete', id)
        return {}
      })
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/Approvalrule.js